// Copyright (c) 2017 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import AccordionList, {getDefaultState as getAccordionListState} from '../state/accordion-list';
import AllClaimsResults, {getDefaultState as getAllClaimsDefaultState} from './all-claims';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../shared/state/create-claim-modal';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const AllClaims = t.struct({
    allClaims: AllClaimsResults,
    busyCounter: BusyCounter,
    claimsAccordion: AccordionList,
    createClaimModal: CreateClaimModalType,
    facets: Facets,
    hasSearchResults: t.Boolean,
    isEditable: t.Boolean,
    reportsAccordion: Accordion,
    searchFilters: SearchFilters
}, {
    name: 'AllClaims',
    strict: true
});

export const getDefaultState = () =>
    new AllClaims({
        allClaims: getAllClaimsDefaultState(),
        busyCounter: getBusyCounterDefaultState(),
        claimsAccordion: getAccordionListState(),
        createClaimModal: getCreateClaimModalTypeDefaultState(),
        facets: getFacetsDefaultState(),
        hasSearchResults: false,
        isEditable: false,
        reportsAccordion: getAccordionDefaultState('all-claims-report'),
        searchFilters: getSearchFiltersDefaultState()
    });

export default AllClaims;



// WEBPACK FOOTER //
// ./src/claim/all-claims/state/index.js